import type { ReactNode } from "react";

interface TransactionSectionProps {
    children: ReactNode;
}

export function TransactionSection({ children }: TransactionSectionProps) {
    return <div className="gap-2 flex flex-col">{children}</div>;
}
